export namespace PublicStateActions {
    export class ShowSplitpane {
        static type = '[Public] Show splitpane';
    }

    export class HideSplitpane {
        static type = '[Public] Hide splitpane';
    }
}
